import { Component, Input, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
// import { Angulartics2 } from 'angulartics2';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
  selector: 'lc-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  @Input() product: any;
  @Input('style') view_style: string = 'list';
  @Output() processProduct: EventEmitter<any> = new EventEmitter();

  private body: HTMLElement = this.document.body;
  selected_product: any;

  total_products_amount: number = 0;

  constructor(@Inject(DOCUMENT) private document: any, public dataService: DataService) { }

  ngOnInit() {
  }

  close_popup(){
    this.startBodyScroll();
    this.selected_product = undefined;
    // this.angulartics2.eventTrack.next(
    //   { action: 'close_detail_popup', properties: { category: 'back_to_listview'  }}
    // );
  }

  open_popup(product?){
    this.stopBodyScroll();
    this.selected_product = product;
    // this.angulartics2.eventTrack.next(
    //   { action: 'open_detail_popup', properties: { category: 'detail_view', label: product.id }}
    // );
  }

  startBodyScroll(){
    this.body.style.overflow = 'auto';
  }

  stopBodyScroll() {
    this.body.style.overflow = 'hidden';
  }

  process(event: { action: string, product: any }) {
    if(event.action === 'add') this.addItem(event.product);
    if(event.action === 'remove') this.removeItem(event.product);
  }

  addItem(product){
    product.order_amount++;
    this.processProduct.emit({ action: 'add', product: product });
  }

  removeItem(product){
    product.order_amount--;
    this.processProduct.emit({ action: 'remove', product: product });
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/product/product.component.ts